<div class="w-full h-full relative">
  <div id="wizard-content">
    <div class="flex flex-col items-center justify-center">
      <div class="flex flex-col justify-center max-w-lg">
        <h2 class="text-2xl font-semibold m-0 mb-6">Remove all rule-sets</h2>
        <p class="m-0 mb-8">
          Are you sure you want to remove all rule-sets from the selected dates?
        </p>
        <div class="flex gap-4">
          <sbnb-button [type]="'secondary'" label="Go back" (click)="onCancel()"></sbnb-button>
          <sbnb-button [type]="'primary-error'" label="Yes, remove all rule-sets" (click)="onConfirm()"></sbnb-button>
        </div>
      </div>
    </div>
  </div>
</div>
